import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { PenLine, Upload, Trash2, Loader2 } from "lucide-react";
import { api, apiErr } from "../../lib/api";

export function CertificateSignatureCard() {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  const input = useRef(null);
  const load = () => api.get("/admin/certificates/signature").then(({ data }) => setStatus(data)).catch(() => setStatus({ configured: false }));
  useEffect(() => { load(); }, []);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      await api.post("/admin/certificates/signature", fd);
      toast.success("Signature saved — new certificates will include it");
      load();
    } catch (e) {
      toast.error(apiErr(e, "Upload failed"));
    } finally {
      setBusy(false);
      if (input.current) input.current.value = "";
    }
  };

  const clear = async () => {
    if (!window.confirm("Remove the uploaded signature? Certificates will go back to the installed default (Dimitrios Drosos, ivory).")) return;
    setBusy(true);
    try { await api.delete("/admin/certificates/signature"); load(); } catch (e) { toast.error(apiErr(e, "Failed")); } finally { setBusy(false); }
  };

  return (
    <div className="rounded-xl bg-[#0f0f0f] border border-[rgba(212,175,55,0.20)] p-5 mt-8" data-testid="admin-cert-signature">
      <div className="flex items-center gap-2 font-heading font-bold uppercase tracking-tight text-slate-50"><PenLine className="w-4 h-4 text-[#E5B842]" /> Certificate signature</div>
      <p className="text-xs text-slate-400 mt-1">President signature printed on Certificates of Membership. The installed signature (Dimitrios Drosos, ivory) is used by default; upload a transparent PNG only to rotate it. Stored privately, used only by the PDF renderer, never served publicly.</p>
      <div className="flex flex-wrap items-center gap-3 mt-4">
        <span className={`text-[10px] font-mono uppercase tracking-wider px-2 py-0.5 rounded border ${status?.configured ? "border-emerald-500/40 text-emerald-300" : "border-slate-600 text-slate-400"}`} data-testid="admin-cert-signature-status">
          {status === null ? "…" : !status.configured ? "not set: signature area stays empty" : status.source === "uploaded" ? "uploaded override active" : "installed default (ivory)"}
        </span>
        <input ref={input} type="file" accept="image/png" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid="admin-cert-signature-input" />
        <button onClick={() => input.current?.click()} disabled={busy} data-testid="admin-cert-signature-upload"
          className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wide bg-[#E5B842] text-black disabled:opacity-50">
          {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />} Upload PNG
        </button>
        {status?.source === "uploaded" && (
          <button onClick={clear} disabled={busy} data-testid="admin-cert-signature-clear"
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wide border border-rose-500/40 text-rose-300">
            <Trash2 className="w-3.5 h-3.5" /> Remove
          </button>
        )}
      </div>
    </div>
  );
}
